export default {
  methods: {
    forwardSearch (searchKey) {
      if (searchKey.length > 0) {
        this.$router.push({
          path: '/search-results',
          query: {
            search: searchKey.trim()
          }
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/search.js